class CredentialsAPI {

    static
    API_CYCLING = 'yDlAPXo8cywxv2Wnz3nHhqOd2eoKLYDHpog5nq1ohBK9crUPNEjUC7PKaMXuCR4a';

        static
    API_AUCTIONS = 'FaPTes4gBbmZcg1Jy1V2tvGbAFDyM4peSBIsyAltB2MlOnqkPYvJPmldnUdjDp24';
}

export default CredentialsAPI;